if (typeof debounce === 'undefined') {
    function debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }
}
/**
 *  @class
 *  @function ThemeHeader
 */

if (!customElements.get('theme-header')) {
    class ThemeHeader extends HTMLElement {
        constructor() {
            super();

        }
        connectedCallback() {
            this.header_section = document.querySelector('.header-section');
            this.menu = this.querySelector('#mobile-menu');
            this.toggle = this.querySelector('.mobile-toggle-wrapper');

            document.addEventListener('keyup', (e) => {
                if (e.code) {
                    if (e.code.toUpperCase() === 'ESCAPE') {
                        this.toggle.removeAttribute('open');
                        this.toggle.classList.remove('active');
                    }
                }
            });
            if (this.classList.contains('header-sticky--active')) {
                document.body.classList.add('header-sticky--active');
            }
            this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
                if (this.toggle.classList.contains('active')) {
                    e.preventDefault();
                    document.body.classList.remove('overflow-hidden');
                    this.toggle.classList.remove('active');
                    this.closeAnimation(this.toggle);
                    $('#wrapper').removeClass('pagewrapper');

                    $(".mobile-toggle span").css({
                        "background": "#FF5F00"
                    });
                    $('.announcement-bar-section').css({
                        display: 'block'
                    })
                    $('.thb-secondary-area-shanebg').css({
                        backgroundColor: '#fff'
                    })

                } else {
                    document.body.classList.add('overflow-hidden');
                    $('#header').css({
                        paddingTop: '10px'
                    })
                    $('.announcement-bar-section').css({
                        display: 'none'
                    })
                    $('.mobile-menu-drawer').css({
                        top: $('#header').height()
                    })
                    $(".mobile-toggle span").css({
                        "background": "#fff"
                    });
                    $('.thb-secondary-area-shanebg').css({
                        backgroundColor: 'rgb(244, 240, 230)'
                    })
                    $('#wrapper').addClass('pagewrapper');
                    setTimeout(() => {
                        this.toggle.classList.add('active');

                    });
                }
            });

            // Read all geometry before writing CSS, at most once per frame.
            this.scheduleHeaderMetrics = () => {
                if (this.headerMetricsFrame != null) return;
                this.headerMetricsFrame = requestAnimationFrame(() => {
                    this.headerMetricsFrame = null;
                    this.updateHeaderMetrics();
                });
            };
            window.addEventListener('scroll', this.scheduleHeaderMetrics, { passive: true });
            window.addEventListener('resize', this.scheduleHeaderMetrics, { passive: true });
            this.headerResizeObserver = new ResizeObserver(this.scheduleHeaderMetrics);
            this.headerResizeObserver.observe(this);
            const announcement = document.querySelector('.announcement-bar-section');
            if (announcement) this.headerResizeObserver.observe(announcement);
            this.scheduleHeaderMetrics();

            // Mobile Navigation transparent header support.
            setTimeout(() => {

                this.mobile_nav = document.querySelector('.header-mobile-navigation');

                if (this.mobile_nav && this.classList.contains('transparent--true')) {
                    this.mobile_nav.classList.add('is-fixed');
                }
            }, 100);
            // Buttons.
            this.menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
            this.menu.querySelectorAll('.parent-link-back--button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
        }
        disconnectedCallback() {
            window.removeEventListener('scroll', this.scheduleHeaderMetrics);
            window.removeEventListener('resize', this.scheduleHeaderMetrics);
            if (this.headerResizeObserver) this.headerResizeObserver.disconnect();
            if (this.headerMetricsFrame != null) cancelAnimationFrame(this.headerMetricsFrame);
            this.headerMetricsFrame = null;
        }
        updateHeaderMetrics() {
            if (!this.header_section) return;
            const scrollY = window.scrollY;
            const top = this.getBoundingClientRect().top;
            const offset = this.header_section.getBoundingClientRect().top;
            const height = this.clientHeight;
            const announcement = document.querySelector('.announcement-bar-section');
            const announcementHeight = announcement ? announcement.clientHeight : 0;
            const properties = {
                '--header-offset': offset + 'px',
                '--header-height': height + 'px',
                '--announcement-height': announcementHeight + 'px'
            };
            if (this.classList.contains('header-sticky--active')) {
                this.classList.toggle('is-sticky', scrollY >= Math.trunc(top) + scrollY && scrollY > 0);
            }
            const style = document.documentElement.style;
            Object.entries(properties).forEach(([name, value]) => {
                if (style.getPropertyValue(name) !== value) style.setProperty(name, value);
            });
        }
        onSummaryClick(event) {
            const summaryElement = event.currentTarget;
            const detailsElement = summaryElement.parentNode;
            const parentMenuElement = detailsElement.closest('.link-container');
            const isOpen = detailsElement.hasAttribute('open');
            if (this.querySelector('.parent-link-back--button')) {
                this.menu.scrollTop = 0;
            }
            setTimeout(() => {
                detailsElement.classList.add('menu-opening');
                parentMenuElement && parentMenuElement.classList.add('submenu-open');
            }, 100);
        }
        onCloseButtonClick(event) {
            event.preventDefault();
            const detailsElement = event.currentTarget.closest('details');
            this.closeSubmenu(detailsElement);
        }
        closeSubmenu(detailsElement) {
            detailsElement.classList.remove('menu-opening');
            this.closeAnimation(detailsElement);
        }
        closeAnimation(detailsElement) {
            let animationStart;

            const handleAnimation = (time) => {
                if (animationStart === undefined) {
                    animationStart = time;
                }

                const elapsedTime = time - animationStart;

                if (elapsedTime < 400) {
                    window.requestAnimationFrame(handleAnimation);
                } else {
                    detailsElement.removeAttribute('open');
                }
            };

            window.requestAnimationFrame(handleAnimation);
        }
    }
    customElements.define('theme-header', ThemeHeader);
}

/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
    class FullMenu extends HTMLElement {
        constructor() {
            super();

            this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');
        }
        connectedCallback() {
            if (!this.submenus.length) {
                return;
            }
            const _this = this;
            // resize on initial load
            document.fonts.ready.then(function() {
                window.addEventListener('resize', debounce(function() {
                    _this.resizeSubMenus();
                }, 100));
            });

        }
        resizeSubMenus() {
            this.submenus.forEach((submenu) => {
                let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');

                sub_submenus.forEach((sub_submenu) => {
                    let w = sub_submenu.offsetWidth,
                        l = sub_submenu.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.offsetWidth,
                        total = w + l;

                    if (total > window.innerWidth) {
                        sub_submenu.parentElement.classList.add('left-submenu');
                    } else if (sub_submenu.parentElement.classList.contains('left-submenu')) {
                        sub_submenu.parentElement.classList.remove('left-submenu');
                    }
                });
            });
        }
    }
    customElements.define('full-menu', FullMenu);
}